export default __webpack_public_path__ + "static/media/lattes.4187d34a.svg";